var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { MembershipOp } from '@towns-protocol/proto';
import { PersistedObservable, persistedObservable } from '../../../observable/persistedObservable';
import { LoadPriority } from '../../../store/store';
import { check, dlogger } from '@towns-protocol/dlog';
import { makeUserStreamId, streamIdFromBytes, userIdFromAddress } from '../../../id';
import { isDefined } from '../../../check';
const logger = dlogger('csb:userMemberships');
let UserMemberships = class UserMemberships extends PersistedObservable {
    riverConnection;
    constructor(id, store, riverConnection) {
        super({ id, streamId: makeUserStreamId(id), initialized: false, memberships: {} }, store, LoadPriority.high);
        this.riverConnection = riverConnection;
    }
    onLoaded() {
        this.riverConnection.registerView(this.onClientStarted);
    }
    onClientStarted = (client) => {
        logger.log('onClientStarted');
        const streamView = this.riverConnection.client?.stream(this.data.streamId)?.view;
        if (streamView) {
            this.initialize(streamView);
        }
        client.addListener('userStreamMembershipChanged', this.onUserStreamMembershipChanged);
        client.addListener('streamInitialized', this.onStreamInitialized);
        return () => {
            client.removeListener('userStreamMembershipChanged', this.onUserStreamMembershipChanged);
            client.removeListener('streamInitialized', this.onStreamInitialized);
        };
    };
    getMembership(streamId) {
        return this.data.memberships[streamId];
    }
    isMember(streamId, membership) {
        return this.getMembership(streamId)?.op === membership;
    }
    isJoined(streamId) {
        return this.isMember(streamId, MembershipOp.SO_JOIN);
    }
    initialize = (streamView) => {
        const memberships = Object.entries(streamView.userContent.streamMemberships).reduce((acc, [streamId, payload]) => {
            acc[streamId] = toUserMembership(payload);
            return acc;
        }, {});
        this.setData({ memberships, initialized: true });
    };
    onStreamInitialized = (streamId) => {
        if (streamId === this.data.streamId) {
            const streamView = this.riverConnection.client?.stream(this.data.streamId)?.view;
            check(isDefined(streamView), 'streamView is not defined');
            this.initialize(streamView);
        }
    };
    onUserStreamMembershipChanged = (streamId, payload) => {
        this.setData({
            memberships: {
                ...this.data.memberships,
                [streamId]: toUserMembership(payload),
            },
        });
    };
};
UserMemberships = __decorate([
    persistedObservable({ tableName: 'userMemberships' })
], UserMemberships);
export { UserMemberships };
function toUserMembership(payload) {
    const { op, streamId: inStreamId } = payload;
    const streamId = streamIdFromBytes(inStreamId);
    return {
        streamId,
        op,
        inviter: payload.inviter ? userIdFromAddress(payload.inviter) : undefined,
        streamParentId: payload.streamParentId
            ? streamIdFromBytes(payload.streamParentId)
            : undefined,
    };
}
//# sourceMappingURL=userMemberships.js.map